/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- COMMENTING - ANALYTICS PAGE : STYLES --------------- ++++++++++ */
export default {
    commentinganalyticspage: {
    }
};
